

import type {PropType} from 'vue'
import {ResponsivePictureOB1DTO} from "../../../../../../../../generated/js/OrderingDtos";

export default {
    name: "ResponsivePictureOb1",
    props: {
        dto: {
            type: Object as PropType<ResponsivePictureOB1DTO>,
            required: true
        },
        cssClasses: {
            type: String,
            required: false,
            default: ''
        }
    },
    data: function() {
        return {}
    },
    computed: {
    },
}

